import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=552023d5"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports